var portfolioTransactionsList = {
	caption: "Portfolio transactions",
	date: "Date",
	time: "Time",
	name: "Name",
	isin: "ISIN",
	transactionType: "Type",
	numberOfShares: "Quantity/Nominal",
	executionPrice: "Execution price",
	executionValue: "Execution value",
	assetClass: "Asset class",
	actions: "Actions",
	buy: "Buy",
	sell: "Sell",
	cash: "Cash",
	payout: "Payout",
	short: "Short",
	cover: "Cover",
	noTransactions: "No results found",
	bond: "Bond",
	commodity: "Commodity",
	currency: "Currency",
	debt: "Debt",
	etf: "ETF",
	fund: "Fund",
	generic: "Generic",
	index: "Index",
	stock: "Stock",
	interestRate: "Interest Rate",
	structuredProduct: "Structured Product",
	investmentProduct: "Investment Product",
	leveragedProduct: "Leveraged Product",
	option: "Option",
	future: "Future"
};
var en = {
	portfolioTransactionsList: portfolioTransactionsList
};

export { en as default, portfolioTransactionsList };
